import { connect } from 'react-redux';
import {
  startPublishStepPoll,
  stopPublishStepPoll,
  abortRequest,
  resetAbort,
} from './publish-steps-actions';
import PublishSteps from '../components/publish-steps';

const mapStateToProps = state => ({
  currentStatus: state.currentStatus.operationInfo,
  error: state.currentStatus.error,
  isPolling: state.currentStatus.shouldPoll,
  menuVisible: state.header.menuVisible,
  isAborting: state.currentStatus.isAborting,
  abortFailure: state.currentStatus.abortFailure,
  hasAnnouncementBanner: state.user.hasAnnouncementBanner,
});

const mapDispatchToProps = {
  startPublishStepPoll,
  stopPublishStepPoll,
  abortRequest,
  resetAbort,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PublishSteps);
